import React, {Component} from 'react';

import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import './styles.scss';

class SelectComponent extends Component {

    render() {
        return (
              <FormControl className={"form-control"}>
                  <Select
                      displayEmpty
                      className={"select graphics-form"}
                      disableUnderline={true}
                      value={this.props.selectedValue}
                      onChange={this.props.onValueChange}
                  >
                      {this.props.values.map((val) =>{
                          return (<MenuItem key={val.value.toString()} value={val}>
                                  {val.label}
                          </MenuItem>);
                      })}
                  </Select>
              </FormControl>
        );
    }
}

export default SelectComponent;


// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/common/select/Select.js